import {
    handleKeyboardDownEvent,
    keyboardInteractions
} from "../../../../react/core/utils/accessibilityHelpers";

// focus an element
var focusElement = function (elementId) {
    setTimeout(function () {
        var myEl = document.querySelector("#" + elementId);
        if (myEl) {
            myEl.focus();
        }
    });
};

//focus the first error in the list
var enableScreenReaderErrors = function (e) {
    e.preventDefault();
    var errorMessagesEl = document.querySelector("#screenReaderErrorMessages");
    errorMessagesEl.querySelector("a:first-child").focus();
};

// this function is called from an ng-click on an individual error message
// focus the input with an error
var focusOnErrorInput = function (e, elementId) {
    e.preventDefault();
    focusElement(elementId);
};

export default {
    focusElement: focusElement,
    enableScreenReaderErrors: enableScreenReaderErrors,
    focusOnErrorInput: focusOnErrorInput,
    handleKeyboardDownEvent,
    keyboardInteractions
};
